const getters = {
  translationModules: (state) => state.translationModules,
  translationFields: (state) => state.translationFields,
  translationFieldDetails: (state) => state.translationFieldDetails,
  versionHistory: (state) => state.versionHistory,
  preFilledData: (state) => state.preFilledData,
};

export default getters;
